module.exports = __webpack_public_path__ + "static/amnizu-410536460e5875ac748a484b9a6f1d05.png";